<template>
  <div
    :class="[
      'u-client-footer-wrapper',
      contrastColor && `has-contrast-color-${contrastColor}`
    ]"
  >
    <!-- Footer client template -->
    <client-template-render-provider v-bind="clientTemplateProps">
      <template v-slot:default="{ $templateData }">
        <template v-if="!!$templateData.body">
          <u-markdown class="u-client-template is-marginless is-size-7">{{
            $templateData.body
          }}</u-markdown>
        </template>
      </template>
    </client-template-render-provider>
    <!-- Powered by Upmind -->
    <template v-if="$store.getters['org/hasUpmindBrandingEnabled']">
      <powered-by-upmind
        class="u-powered-by-link"
        :contrast-color="contrastColor"
      />
    </template>
    <!-- Language control -->
    <template v-if="showLangSelector">
      <brand-language-selector :class="['u-language-control']" />
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ClientTemplateSlotCodes } from "@/data/enums/templates";
import type { PropType } from "vue";
import type { ContrastColor } from "@/data/enums/ui";
import type { IState } from "@/store";

export default defineComponent({
  name: "ClientFooter",
  components: {
    "powered-by-upmind": () => import("@/skeleton/poweredByUpmind.vue"),
    "brand-language-selector": () =>
      import("@/components/app/global/brand/brandLanguageSelector.vue"),
    "client-template-render-provider": () =>
      import(
        `@/components/app/global/templates/clientTemplateRenderProvider.vue`
      )
  },
  props: {
    contrastColor: {
      type: String as PropType<ContrastColor | null>,
      default: null
    }
  },
  computed: {
    clientTemplateProps() {
      return {
        code: ClientTemplateSlotCodes.FOOTER,
        objectId: (this.$store.state as IState).brand?.id,
        withAccessToken: false
      };
    },
    showLangSelector() {
      if (this.$store.getters.isAdminContext)
        return !this.$store.getters[`auth/admin/isAuthenticated`];
      return !this.$store.getters[`auth/client/isAuthenticated`];
    }
  }
});
</script>

<style lang="scss" scoped>
.u-client-footer-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  @include mobile {
    justify-content: center;
  }
}

.u-client-footer-wrapper.has-contrast-color-black {
  .u-client-template ::v-deep *,
  .u-language-control ::v-deep .dropdown-trigger a {
    color: $black;
  }
}

.u-client-footer-wrapper.has-contrast-color-white {
  .u-client-template ::v-deep *,
  .u-language-control ::v-deep .dropdown-trigger a {
    color: $white;
  }
}

.u-client-footer-wrapper:not([class*="has-contrast-color-"]) {
  .u-client-template ::v-deep *,
  .u-language-control ::v-deep .dropdown-trigger a {
    color: var(--brand-color-contrast, $primary-invert) !important;
  }
}

.u-powered-by-link {
  font-size: $size-7;
  &:only-child {
    margin: 0 auto;
  }
}

.u-language-control {
  @include tablet {
    margin-left: auto;
  }

  ::v-deep .dropdown-trigger a {
    font-size: $size-7;
  }
}
</style>
